import type { TreeTag } from '#domains/tags';

const filterDecendants = (tags: TreeTag[], tag: TreeTag) => {
  return tags.filter(t => t.ancestors?.includes(tag.id));
};

export default filterDecendants;
